import { Container, SectionHeading } from '../ui';

/**
 * Why accessibility matters — four facts, each with its primary source.
 * Checked 14 Oct 2026; update the numbers (and `asOf`) when a source
 * publishes a new edition.
 */
const FACTS = [
  {
    asOf: 'WHO, 2023',
    body: 'people, 1 in 6 worldwide, live with a significant disability.',
    href: 'https://www.who.int/news-room/fact-sheets/detail/disability-and-health',
    stat: '1.3 billion',
  },
  {
    asOf: 'WebAIM Million, 2026',
    body: 'of the top million home pages have detectable WCAG failures.',
    href: 'https://webaim.org/projects/million/',
    stat: '95.9%',
  },
  {
    asOf: 'UsableNet, 2025 year-end report',
    body: 'digital accessibility lawsuits filed in the US in 2025.',
    href: 'https://info.usablenet.com/2025-year-end-report-on-web-accessibility-lawsuits',
    stat: '5,000+',
  },
  {
    asOf: 'Directive (EU) 2019/882',
    body: 'the European Accessibility Act began applying to digital products and services sold in the EU (28 June).',
    href: 'https://eur-lex.europa.eu/eli/dir/2019/882/oj',
    stat: '2025',
  },
];

export function WhyItMatters() {
  return (
    <section
      aria-labelledby="why-title"
      className="py-24 md:py-32"
      id="why-accessibility"
    >
      <Container>
        <SectionHeading
          eyebrow="Why it matters"
          id="why-title"
          intro="If people can’t use your product, they can’t buy from you, sign up or get help. Accessibility is better for everyone, and increasingly it’s the law."
          title="One in six people. Every product."
        />
        <ul className="mt-12 grid gap-x-8 gap-y-10 sm:grid-cols-2 lg:grid-cols-4">
          {FACTS.map((fact) => (
            <li className="border-t border-hairline pt-6" key={fact.stat}>
              <p className="font-report text-report-stat font-medium text-text-primary">
                {fact.stat}
              </p>
              <p className="mt-2 text-ui-lg text-text-secondary">{fact.body}</p>
              <a
                className="mt-3 inline-block text-caption text-text-secondary underline hover:text-text-primary"
                href={fact.href}
                rel="noopener noreferrer"
                target="_blank"
              >
                {fact.asOf}
                <span className="sr-only"> (opens in a new tab)</span>
              </a>
            </li>
          ))}
        </ul>
      </Container>
    </section>
  );
}
